import { Messenger } from '@plug-core/interfaces/messenger'
import { usePermissions } from '@plug-core/state'

type SessionTerminatePayload = {
  principal: string
  host: string
  isForwarded?: boolean
}

const removePermission = (payload: SessionTerminatePayload) => {
  usePermissions.getState().removePermission(payload.principal, payload.host)
}

const forwardMessage = (payload: SessionTerminatePayload, messenger: Messenger) => {
  if (!payload.isForwarded) {
    payload.isForwarded = true
    messenger.send('session-terminate', payload)
  }
}

const handleBackgroundMessage = ({
  inpageMessenger,
  popupMessenger,
}: {
  inpageMessenger: Messenger
  popupMessenger: Messenger
}) => {
  inpageMessenger.reply('session-terminate', async (payload: SessionTerminatePayload) => {
    removePermission(payload)
    forwardMessage(payload, popupMessenger)
  })
  popupMessenger.reply('session-terminate', async (payload: SessionTerminatePayload) => {
    removePermission(payload)
    forwardMessage(payload, inpageMessenger)
  })
}

export default handleBackgroundMessage
